// 全局样式必须是第一个 import——级联约定见 styles/index.css 头注释。
import "./styles/index.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MarketRouteBoundary } from "./features/market-observation/MarketRouteBoundary";
import { AuthBoundary } from "./features/auth/AuthBoundary";
import { AccountSyncBoundary } from "./features/account-sync/AccountSync";

// 【第一代总入口已于 2026-08-26 归档】原来的 <App/>（single-asset / ledger /
// portfolio-dashboard / import / compare / collections / agent-chat）搬到了
// legacy/frontend/src/App.jsx，本目录下不再有它们。
// 旧地址由 MarketRouteBoundary 处理；归档恢复办法见 legacy/README.md。
function UnreachableLegacyRoute() {
  return <main style={{ padding: "2rem" }}>这个页面已下线。</main>;
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary" role="alert">
          <div>
            <h2>页面暂时无法显示</h2>
            <p>{String(this.state.error)}</p>
            <button className="primary" onClick={() => this.setState({ error: null })}>重新尝试</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthBoundary>
          {({ session, onLogout }) => (
            <AccountSyncBoundary session={session}>
            <MarketRouteBoundary
              fallback={<UnreachableLegacyRoute />}
              session={session}
              onLogout={onLogout}
            />
            </AccountSyncBoundary>
          )}
        </AuthBoundary>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
